//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import { Tabs, Tab, List, PullRefresh } from "vant";
import DisContent from "./components/dis-content.vue";
import { commonApi } from "@/common/index";

export default {
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    DisContent,
  },
  data() {
    return {
      active: 0, //tab 选中
      tablist: [], // tab切换数据 即优惠文章类型
      list: [], // 文章列表
      total: null,
      pages: {
        pageNo: 1,
        pageSize: 5,
      },
      refreshing: false,
      loading: true,
      finished: false,
      scrollTop: 0,
    };
  },
  created() {
    this._getBonusArticleType();
  },
  activated() {
    if (this.$route.meta.scrollTop) {
      this.$refs.discountsWrap.scrollTop = this.$route.meta.scrollTop;
    }
  },
  beforeRouteLeave(to, from, next) {
    from.meta.scrollTop = this.$refs.discountsWrap.scrollTop;
    next();
  },
  deactivated() {
    console.log(this.$refs.discountsWrap.scrollTop);
  },
  methods: {
    handleTabChange() {
      this.pages.pageNo = 1;
      this.list = [];
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },

    _getBonusArticleType() {
      // 查询优惠文章类型
      commonApi.DISCOUNTS.queryBonusArticleTypeList()
        .then((data) => {
          this.tablist = data || [];
          this.onLoad();
        })
        .catch((err) => {});
    },

    _getLists() {
      // 获取文章列表
      commonApi.DISCOUNTS.queryBonusArticleInfoList({
        typeId: this.active,
        platform: "app",
        ...this.pages,
      })
        .then((data) => {
          const { list, total } = data;
          this.total = total;
          this.list = [...this.list, ...list];
          if (this.list.length === this.total) {
            this.finished = true;
          }
        })
        .catch((err) => {
          if (this.pages.pageNo === 1) {
            this.list = [];
            this.total = null;
          }
          this.finished = true;
        })
        .finally(() => {
          this.loading = false;
          this.refreshing = false;
        });
    },

    onLoad() {
      this._getLists();
      this.pages.pageNo += 1;
    },

    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.list = [];
      this.pages.pageNo = 1;
      this.onLoad();
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/discounts/index.vue